import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css';
import axios from "axios";
import VueRouter from 'vue-router';
import router from './router';
import store from './store';

Vue.prototype.$axios=axios;
// 后端服务地址：可用环境变量 VUE_APP_API_BASE 覆盖（生产构建设为 /api 走 Nginx 反代），默认本地 5070
Vue.prototype.$httpUrl=process.env.VUE_APP_API_BASE || 'http://localhost:5070'
Vue.config.productionTip = false
//Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(ElementUI,{size:'small'});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
